/* eslint-disable @typescript-eslint/no-unused-expressions */
import { API_METHODS } from "services/api";
import {
  NOTIFICATION_CREATE_PAYLOAD,
  NOTIFICATION_CHANGED_EVENTS,
  NOTIFICATION_CREATE_SUCCESS,
  NOTIFICATION_CREATE_ERROR,
  NOTIFICATION_ASYNC_ALL,
  NOTIFICATION_LOADING_SUCCESS,
  NOTIFICATION_DELETE_ID,
} from "store/reducers/notifications/notifications.reducer";
import { takeLatest, fork, take, select, call, put, cancel, takeEvery } from "typed-redux-saga";

function* getNotifications() {
  try {
    yield put(
      NOTIFICATION_CHANGED_EVENTS({
        loading: true,
        success: false,
        error: false,
      })
    );
    const token = yield* select((state) => state.auth.auth.token);
    const notify = yield* select((state) => state.notifications);
    const Request = yield* call(API_METHODS.GET_ALL_NOTIFICATIONS, token, notify.page, notify.pageSize, notify.search);
    yield put(NOTIFICATION_LOADING_SUCCESS(Request?.data));
    return Request;
  } catch (error) {
    yield put(
      NOTIFICATION_CHANGED_EVENTS({
        loading: false,
        success: false,
        error: true,
      })
    );
    return error;
  } finally {
    yield put(
      NOTIFICATION_CHANGED_EVENTS({
        loading: false,
      })
    );
  }
}
function* getAllNotificationsFoork() {
  const getNotify = yield* call(getNotifications);
  //console.log("REST", getNotify);
}
function* createNotificationSaga(action: any) {
  //console.log("createNotificationSaga");
  const token = yield* select((state) => state.auth.auth.token);
  try {
    const { id, ...normalize } = action.payload;
    yield* put(NOTIFICATION_CHANGED_EVENTS({ loading: true, success: false, error: false }));
    //console.log(action.payload);
    var result;
    if (id !== undefined && id > 0) {
      result = yield* call(API_METHODS.UPDATE_A_NOTIFICATION, token, id, normalize);
    } else {
      result = yield* call(API_METHODS.CREATE_A_NOTIFICATION, token, normalize);
    }
    yield put(NOTIFICATION_CREATE_SUCCESS({ msg: "Notificação enviada com sucesso" }));
    yield put(
      NOTIFICATION_CHANGED_EVENTS({
        loading: false,
        success: true,
        error: false,
      })
    );
    return result;
  } catch (error) {
    yield* put(
      NOTIFICATION_CREATE_ERROR({ msg: "Ocorreu um erro ao deletar o usuário" })
    );
    yield put(
      NOTIFICATION_CHANGED_EVENTS({
        loading: false,
        success: false,
        error: true,
      })
    );
  } finally {
    //yield* put(NOTIFICATION_CHANGED_EVENTS({ loading: false }));
  }
}
function* asyncDeleteNotification(action: any) {
  const { payload } = action;
  yield* put(
    NOTIFICATION_CHANGED_EVENTS({
      loading: true,
      success: false,
    })
  );
  //console.log(`asyncDeleteNotification`);
  //console.log(payload);
  const { id } = payload;
  const token = yield* select((state) => state.auth.auth.token);
  try {
    let Request;
    if ((id) && (id !== 0)) {
      //console.log(id);
      Request = yield* call(API_METHODS.DELETE_A_NOTIFICATION, token, id);
    }
    //console.log(Request);
    yield* put(NOTIFICATION_CREATE_SUCCESS({ msg: "Notification deletado corretamente" }));
    yield* put(
      NOTIFICATION_CHANGED_EVENTS({
        loading: false,
        success: true,
        error: false,
      })
    );
    return Request;
  } catch (error) {
    yield* put(
      NOTIFICATION_CREATE_ERROR({ msg: "Ocorreu um erro ao deletar a notificação" })
    );
    yield* put(
      NOTIFICATION_CHANGED_EVENTS({
        loading: false,
        success: false,
        error: true,
      })
    );
  } finally {
    /*yield put(
      USER_CHANGED_STATE({
        loading: false,
      })
    );*/
    yield console.log("FINALLY");
  }
}
export function* notificationsSaga() {
  while (true) {
    yield* take([NOTIFICATION_ASYNC_ALL.type]);
    const asyncAllUsers = yield* fork(getAllNotificationsFoork);
    if (!asyncAllUsers) {
      yield* cancel(asyncAllUsers);
    }
    //yield* takeLatest(NOTIFICATION_DELETE_ID.type, asyncDeleteNotification);
  }
}
export function* notificationSaga() {
  /*while (true) {
    const valid = yield* take(NOTIFICATION_CREATE_PAYLOAD.type) as any;
    const autoLoopValidate = yield* call(createNotificationSaga, valid);
    if (!autoLoopValidate) {
      yield* cancel(autoLoopValidate);
    }
  }*/
  yield* takeLatest(NOTIFICATION_CREATE_PAYLOAD.type, createNotificationSaga);
  yield* takeLatest(NOTIFICATION_DELETE_ID.type, asyncDeleteNotification);
}
